<template>
  <div>
    <div class="split-section d-flex flex-wrap login-page">
      <info></info>
      <div
        class="right-infosec d-flex align-items-center text-center flex-wrap justify-content-center"
      >
        <div class="signup-form login-form">
          <div class="gr-form" v-if="this.userDetails.isFirstLogin == true">
            <check-email-confirmation @resetLoginForm="resetLoginForm"></check-email-confirmation>
          </div>
          <div class="gr-form" v-else>
            <h2>Login</h2>
            <form @submit="login" name="loginForm">
              <div
                class="alert alert-danger alert-dismissible"
                role="alert"
                v-if="showAlertMessage"
              >
                {{apiErrorMessage}}
                <img
                  class="close"
                  src="assets/images/close.svg"
                  data-dismiss="alert"
                  aria-label="close"
                  @click="showAlertMessage=!showAlertMessage"
                />
              </div>

              <div
                class="alert alert-success alert-dismissible"
                role="alert"
                v-if="showSuccessAlertMessage"
              >
                {{apiSuccessMessage}}
                <img
                  class="close"
                  src="assets/images/close.svg"
                  data-dismiss="alert"
                  aria-label="close"
                  @click="showSuccessAlertMessage=!showSuccessAlertMessage"
                />
                <!-- <a href="#" class="close" data-dismiss="alert" aria-label="close" @click="showSuccessAlertMessage=!showSuccessAlertMessage">&times;</a> -->
                <!-- <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                  @click="showSuccessAlertMessage=!showSuccessAlertMessage"
                >
                  <span aria-hidden="true">&times;</span>
                </button>-->
              </div>

              <div class="form-group">
                <label for="email" class="email">Email</label>
                <input
                  type="text"
                  class="form-control"
                  id="email"
                  v-model="email"
                  name="email"
                  data-vv-as="email"
                  v-validate="'required|email'"
                />
                <span class="invalid-feedback">{{ errors.first('email') }}</span>
              </div>
              <div class="form-group">
                <label for="password" class="password">Password</label>
                <input
                  :type="passwordFieldType"
                  class="form-control"
                  id="password"
                  v-model="password"
                  name="password"
                  ref="password"
                  data-vv-as="password"
                  v-validate="'required'"
                />

                <span
                  toggle="#password"
                  :class="passwordShowIcon"
                  @click="switchPasswordVisibility"
                ></span>

                <span class="invalid-feedback">{{ errors.first('password') }}</span>
              </div>
              <div class="form-group text-right">
                <router-link to="/forgotPassword">Forgot Password?</router-link>
              </div>
              <div class="form-group">
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="disabled == true"
                >{{buttonText}}</button>
              </div>
              <div class="form-note text-center">
                Don't have an account yet? You can
                <router-link to="/signup">Sign Up here</router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--MODAL -->
      <div
        class="modal fade"
        id="email-inactive-modal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-body">{{apiErrorMessage}}</div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
              <button
                type="button"
                class="btn btn-outline-success"
                @click="resendVerificationEmail"
              >Resend Email</button>
            </div>
          </div>
        </div>
      </div>
      <!--END MODAL-->
    </div>
  </div>
</template>
<script>
import Info from "./Info";
import CheckEmailConfirmation from "./CheckEmailConfirmation";
import {
  LOGIN,
  SET_USER_LOGGED,
  CONFIRM_EMAIL,
  RESEND_EMAIL
} from "../../store/auth/action.type";
import { mapState } from "vuex";

export default {
  components: {
    info: Info,
    "check-email-confirmation": CheckEmailConfirmation
  },
  data() {
    return {
      email: "",
      password: "",
      apiSuccessMessage: "",
      apiErrorMessage: "",
      showAlertMessage: false,
      displayResendLinkMessage: false, //incase email is not activated or verified
      showSuccessAlertMessage: false, //for success alert message
      sharedEvent: null,
      sharedEventId: false,
      showPassword: false,
      buttonText: "Login",
      disabled: false,
      passwordFieldType: "password",
      passwordShowIcon: "fa fa-fw fa-eye field-icon toggle-password"
    };
  },
  computed: {
    ...mapState({
      userDetails: state => state.auth.userDetails
    })
  },
  created() {
    this.sharedEvent = JSON.parse(localStorage.getItem("sharedEvent"));
    this.sharedEventId = localStorage.getItem("sharedEventId");
    this.$validator.extend("passwordFormat", {
      getMessage: () =>
        "Password must contain at least one uppercase, lowercase, digit and 8 characters long",
      validate: value =>
        value.match(
          /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z])[A-Za-z\d@$!%*#?&]{8,}$/
        ) !== null
    });
  },
  methods: {
    login(e) {
      e.preventDefault();
      const loginDetails = {
        email: this.email,
        password: this.password
      };
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.disabled = true;
          this.buttonText = "Please wait...";
          this.$store
            .dispatch(LOGIN, loginDetails)
            .then(response => {
              if (response.status == 200) {
                localStorage.setItem(
                  "GiftRegistryAccessToken" +
                    process.env.VUE_APP_ACCESS_TOKEN_NAME,
                  response.headers.accesstoken
                );
                localStorage.setItem(
                  "GiftRegistryRefreshToken" +
                    process.env.VUE_APP_ACCESS_TOKEN_NAME,
                  response.headers.refreshtoken
                );
                if (
                  localStorage.getItem(
                    "GiftRegistryRefreshToken" +
                      process.env.VUE_APP_ACCESS_TOKEN_NAME
                  )
                ) {
                  // this.showSpinner = true
                  this.$store.dispatch(SET_USER_LOGGED, true);
                }
                localStorage.user = JSON.stringify(response.data.data);
              }
              this.$store
                .dispatch(CONFIRM_EMAIL, response.data.data._id)
                .then(response => {
                  if (response.status != 200) {
                    localStorage.removeItem(
                      "GiftRegistryAccessToken" +
                        process.env.VUE_APP_ACCESS_TOKEN_NAME
                    );
                    localStorage.removeItem(
                      "GiftRegistryRefreshToken" +
                        process.env.VUE_APP_ACCESS_TOKEN_NAME
                    );
                    
                    this.$store.dispatch(SET_USER_LOGGED, false);
                    // this.showSpinner = false
                    this.apiErrorMessage = response.data.message;
                    this.showAlertMessage = true;
                  } else {
                    // this.$store.dispatch(SET_USER_LOGGED, true);
                    if (
                      localStorage.getItem(
                        "GiftRegistryRefreshToken" +
                          process.env.VUE_APP_ACCESS_TOKEN_NAME
                      )
                    ) {
                      this.$store.dispatch(SET_USER_LOGGED, true);
                    }
                    if (this.sharedEventId) {
                      return this.$router.push({
                        path: "/wishlist/" + this.sharedEventId
                      });
                    }
                    // this.$router.push({ name: "Dashboard" });
                    this.$router.push({ name: "Dashboard" });
                  }
                  this.disabled = false;
                  this.buttonText = "Login";
                })
                .catch(error => {
                  this.disabled = false;
                  this.buttonText = "Login";
                  localStorage.removeItem(
                    "GiftRegistryAccessToken" +
                      process.env.VUE_APP_ACCESS_TOKEN_NAME
                  );
                  localStorage.removeItem(
                    "GiftRegistryRefreshToken" +
                      process.env.VUE_APP_ACCESS_TOKEN_NAME
                  );
                  
                  this.$store.dispatch(SET_USER_LOGGED, false);
                  // this.showSpinner = false
                  this.apiErrorMessage = error.response.data.message;
                  this.displayResendLinkMessage = true;
                  this.showModal();
                });
            })
            .catch(error => {
              this.disabled = false;
              this.buttonText = "Login";
              this.apiErrorMessage = error.response.data.message;
              this.showAlertMessage = true;
            });
        }
      });
    },
    showModal() {
      $("#email-inactive-modal").modal("show");
    },
    resendVerificationEmail() {
      $("#email-inactive-modal").modal("hide");
      this.$store
        .dispatch(RESEND_EMAIL, this.email)
        .then(response => {
          this.apiSuccessMessage = response.data.message;
          this.showSuccessAlertMessage = true;
        })
        .catch(error => {
          this.apiErrorMessage = error.response.data.message;
          this.showAlertMessage = true;
        });
    },
    resetLoginForm() {
      //reset field value if directed from CheckEmailConfirmation component
      this.email = "";
      this.password = "";
    },

    switchPasswordVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
      this.passwordShowIcon =
        this.passwordShowIcon === "fa fa-fw fa-eye field-icon toggle-password"
          ? "fa fa-fw fa-eye-slash field-icon toggle-password"
          : "fa fa-fw fa-eye field-icon toggle-password";
    }
  },
  // watch: {
  //   showAlertMessage(newData) {
  //     if (newData) {
  //       var self = this;
  //       setTimeout(function() {
  //         self.showAlertMessage = false;
  //         // self.showSpinner = false;
  //       }, 2000);
  //     }
  //   }
  // },
  mounted() {
    this.$store.dispatch(SET_USER_LOGGED, false);
  }
};
</script>
